import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-next',
  templateUrl: './next.component.html',
  styleUrls: ['./next.component.css']
})
export class NextComponent implements OnInit {

  @Input() onShowPeriod;
  step: String = 'next';
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/next/next.component.ts